import { apiClient } from './apiClient';

const createAutomode = async (payload) => {
  return await apiClient.post('/dashboard/automode', payload);
};

const fetchAutomodes = async (payload) => {
  return await apiClient.get('/dashboard/automodes', payload);
};

const updateAutomode = async (id, payload) => {
  return await apiClient.patch(`/dashboard/automode/${id}`, payload);
};

const deleteAutomode = async (id) => {
  return await apiClient.delete_req(`/dashboard/automode/${id}`);
};

export const automodeApi = {
  createAutomode,
  fetchAutomodes,
  updateAutomode,
  deleteAutomode
};
